import React, {createContext, useState} from 'react';
import PropTypes from 'prop-types';

export const MediaContext = createContext({});

export const Provider = (props) => {
  const {children} = props;

  const [selectedMediaId, setSelectedMediaId] = useState(null);
  const [mediaList, setMediaList] = useState([]);
  const [selectedRef, setSelectedRef] = useState({});
  const [readOnly, setReadOnly] = useState(false);
  const [viewType, setViewType] = useState('LIST');
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [viewing, setViewing] = useState(false);
  const [editing, setEditing] = useState(false);

  const mediaContext = {
    selectedMediaId,
    setSelectedMediaId,
    mediaList,
    setMediaList,
    selectedRef,
    setSelectedRef,
    readOnly,
    setReadOnly,
    viewType,
    setViewType,
    loading,
    setLoading,
    reloading,
    setReloading,
    viewing,
    setViewing,
    editing,
    setEditing,
  };

  return (
    <MediaContext.Provider value={mediaContext}>
      {children}
    </MediaContext.Provider>
  );
};

export const {Consumer} = MediaContext;

Provider.propTypes = {
  children: PropTypes.any,
};
